<template>
  <div class="opened-visit-header-panel text-center text-white small"
       v-if="showHeader">
    <div class="d-inline-block">
      {{ $t('visit_in_progress') }}: {{ visit.record.patient.full_name }} {{ visit.record.readableStart }}
    </div>
    <div class="d-inline-block ml-3"
         v-if="totalSecondsPassed > 0">
      {{ paddedDigit(hours) }}:{{ paddedDigit(minutes) }}:{{ paddedDigit(seconds) }}
    </div>
    <div class="d-inline-block ml-3">
      <router-link class="text-white"
                   :to="{ name: 'PatientVisitPage', params: { id: visit.record.patient.id, visitid: visit.record_id, page: 'teeth' } }">
        {{ $t('move_to_visit') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import moment from "moment"
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  visit: {
    type: Object
  }
})

const store = useStore()

const totalSecondsPassed = ref(0)
let interval = null

const user = computed(() => store.state.auth.user)
const hours = computed(() => Math.floor(totalSecondsPassed.value / 3600))
const minutes = computed(() => Math.floor((totalSecondsPassed.value % 3600) / 60))
const seconds = computed(() => totalSecondsPassed.value % 60)

// only the one who opened the visit sees it
const showHeader = computed(() => {
  return props.visit
      && props.visit.created_by == user.value.id
      && props.visit.record
      && props.visit.record.patient
})

const paddedDigit = (digit) => {
  return digit < 10 ? `0${digit}` : digit
}

const launchTimer = () => {
  if(interval) clearInterval(interval)
  if(!props.visit) return
  interval = setInterval(() => {
    totalSecondsPassed.value = moment().diff(props.visit.created_at, 'seconds')
  }, 1000)
}

onMounted(() => {
  launchTimer()
})

watch(() => props.visit, (val) => {
  if(val) launchTimer()
  if(!val && interval) clearInterval(interval)
})

onBeforeUnmount(() => {
  if(interval) clearInterval(interval)
})
</script>

<style scoped>
.opened-visit-header-panel {
  position: relative;
  padding: 2px 15px;
  z-index: 20;
  background: #5E9246;
}
</style>
